module.exports = __webpack_public_path__ + "img/code_big.a6c4c38d.png";